import { GlobalAppState } from '@model/state';
import { CMSComponentTypes } from '@components/cms';

export const getComponentsData = (cmsComponentType: CMSComponentTypes) => (state: GlobalAppState) =>
  state.componentsData[cmsComponentType];
